module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-3.f542e66d.png";